var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CheckCircleFilledSvg from './check-circle-filled.icon.svg';
export const CheckCircleFilledIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, fillOpacity: 1, SvgComponent: CheckCircleFilledSvg }));
_react_refresh_temp_1 = CheckCircleFilledIcon;
$RefreshReg$(_react_refresh_temp_1, "CheckCircleFilledIcon");
